import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import classes from "./index.module.css";
import SideNavBar from "./Sidebar";
import Header from "./Header";
// use redux provider to get the state
import { useDispatch, useSelector } from "react-redux";
import {
  authApi,
  getAuthorizationHeader,
} from "../api-calls/user-requests";
import {
  GET_USER,
  SUBSCRIPTION_LIST,
  TEAM_MEMBERS_LIST,
} from "../api-calls/api-urls";
import { getMqttData } from "../utilities/commonFunctions";
import { fetchPendingExpenseCount } from "../utilities/expenses";
import { ToggleSideBar } from "../Redux/actions/user-actions";

const DefaultLayout = () => {
  console.log("[DefaultLayout] render");
  const dispatch = useDispatch();
  const [plans, setPlans] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [loggedUser, setLoggedUser] = useState();
  const [membersList, setMembersList] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const togglesidebar = useSelector((state) => state.allUsers.togglesidebar);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  const teamMembersList = useSelector((state) => state.allUsers.teamMembersList);
  console.log("[DefaultLayout] teamMembersList.length =", teamMembersList.length, "| loggedUser =", loggedUser?._id ?? "null");
  const currentUserStr = sessionStorage.getItem("userInfo");
  const currentUser = currentUserStr ? JSON.parse(currentUserStr) : null;
  const getCurrentLoggedUser = async () => {
    if (!currentUser?._id) return;
    console.log("[DefaultLayout] getCurrentLoggedUser called, currentUser._id =", currentUser?._id);
    try {
      const { data } = await authApi.get(`${GET_USER}/${currentUser._id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      console.log("[DefaultLayout] getCurrentLoggedUser SUCCESS, company =", data?.company);
      setLoggedUser(data);
    } catch (error) {
      console.error("[DefaultLayout] getCurrentLoggedUser ERROR:", error?.response?.status, error?.message);
    }
  };
  const getTeamMembersData = async () => {
    console.log("[DefaultLayout] getTeamMembersData called, company =", loggedUser?.company);
    try {
      const { data } = await authApi.get(
        `${TEAM_MEMBERS_LIST}/${loggedUser?.company?._id || loggedUser?.company}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      console.log("[DefaultLayout] getTeamMembersData SUCCESS, count =", data.length);
      if (data.length > 0) {
        setMembersList(data);
        dispatch({ type: "TEAM_MEMBERS_LIST", payload: data });
      }
    } catch (error) {
      console.error("[DefaultLayout] getTeamMembersData ERROR:", error?.response?.status, error?.message);
    }
  };

  useEffect(() => {
    console.log("[DefaultLayout] effect[loggedUser, teamMembersList] fired — loggedUser:", !!loggedUser, "| teamMembersList.length:", teamMembersList.length);
    if (loggedUser && teamMembersList.length === 0) {
      getTeamMembersData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedUser, teamMembersList]);

  useEffect(() => {
    console.log("[DefaultLayout] effect[] (mount) — calling getCurrentLoggedUser");
    getCurrentLoggedUser();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const changeStatus = async (message) => {
  //   // console.log(message);
  //   let updatedTeamMembersList;
  //   if (message) {
  //     const findMember = await teamMembersList.find(
  //       (member) => member.user_id._id === message.user_id
  //     );

  //     console.log("tEAMmEMBER", teamMembersList);

  //     if (findMember) {
  //       updatedTeamMembersList = await teamMembersList.map((member) => {
  //         if (member.user_id._id === findMember.user_id._id) {
  //           return {
  //             ...member,
  //             status: message.status,
  //           };
  //         }
  //         return member;
  //       });
  //       console.log(updatedTeamMembersList);
  //     }
  //     dispatch({
  //       type: "TEAM_MEMBERS_LIST",
  //       payload: updatedTeamMembersList,
  //     });
  //   }
  // };

  // Establish MQTT connection as soon as loggedUser is available
  useEffect(() => {
    if (loggedUser?.company) {
      console.log("[DefaultLayout] loggedUser ready — initiating MQTT connection");
      getMqttData(loggedUser.company?._id || loggedUser.company, [], dispatch, "status");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedUser]);

  // Once members load, re-subscribe to their individual status topics
  useEffect(() => {
    console.log("[DefaultLayout] effect[membersList] fired — membersList.length:", membersList.length);
    if (membersList && membersList.length > 0) {
      console.log("[DefaultLayout] members loaded — subscribing to member status topics");
      getMqttData(loggedUser?.company?._id || loggedUser?.company, membersList, dispatch, "status");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [membersList]);

  // Sidebar "Expense Approvals" badge. Web gets no push, so refresh on load
  // and whenever the leader comes back to the tab.
  useEffect(() => {
    if (!loggedUser?._id) return undefined;
    fetchPendingExpenseCount(dispatch);
    const onVisible = () => {
      if (document.visibilityState === "visible") fetchPendingExpenseCount(dispatch);
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedUser?._id]);

  const getPlansDetails = async () => {
    try {
      const { data } = await authApi.get(SUBSCRIPTION_LIST);
      setPlans(data);
      if (data?.length > 0 && data[0].durations?.length > 0) {
        setSelectedValue(data[0].durations[0]._id);
      }
    } catch (err) {
      console.error("Error fetching plans", err);
    }
  };

  useEffect(() => {
    getPlansDetails();
  }, []);
  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Header />
      </div>
      <div className={classes.mainLayout}>
        {isMobile && togglesidebar && (
          <div
            className={classes.sidebarBackdrop}
            onClick={() => dispatch(ToggleSideBar(false))}
          />
        )}
        <div className={togglesidebar ? classes.sidebar : classes.smallSidebar}>
          <SideNavBar />
        </div>
        <div className={classes.content}>
          <div className={classes.scrollableOutlet}>
            <Outlet context={{ plans, selectedValue }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefaultLayout;
